/**
 * Order status page — consumes the portable JSON contract.
 * Shopify App Proxy today (/apps/order); same payload if the API host changes.
 */
(function () {
  var STAGES = [
    { n: 1, name: "Order confirmed" },
    { n: 2, name: "In production" },
    { n: 3, name: "Quality checked" },
    { n: 4, name: "In transit" },
    { n: 5, name: "Arrived locally" },
    { n: 6, name: "Delivery being arranged" },
    { n: 7, name: "Delivery booked" },
    { n: 8, name: "Delivered" },
  ];
  var GENERIC = "If that matches an order, we have sent you a link.";
  var NOT_FOUND = "We could not find an order with that number and email. Both are in your confirmation email.";
  var EXPIRED = "That link has expired. Enter your order number and the email on the order to see it again.";

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function stageName(n, market) {
    // Stage 5 is "Arrived locally" for every market (Ben, 3 November 2026).
    var hit = STAGES.filter(function (s) { return s.n === Number(n); })[0];
    return hit ? hit.name : "";
  }

  function explainStages(market) {
    return STAGES.map(function (s) {
      return { n: s.n, name: stageName(s.n, market), current: false };
    });
  }

  function daysAgo(iso) {
    if (!iso) return 0;
    var t = new Date(iso).getTime();
    if (!isFinite(t)) return 0;
    return Math.floor((Date.now() - t) / 86400000);
  }

  function formatDate(iso) {
    if (!iso) return "";
    var d = new Date(iso);
    if (!isFinite(d.getTime())) return String(iso);
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
  }

  function mockPayload(kind, stage, market) {
    if (kind === "expired") return { status: "expired", message: EXPIRED };
    if (kind === "sent" || kind === "notfound") return { status: "sent", message: GENERIC };
    if (kind === "cancelled") {
      return {
        status: "cancelled",
        message: "This order was cancelled on 12 March 2026. If that is wrong, contact us.",
        order: { reference: "1042", cancelled_at: "2026-03-12", updated_by_hand: true },
      };
    }
    if (kind === "refunded") {
      return {
        status: "refunded",
        message: "Refunded on 12 March 2026.",
        order: { reference: "1042", refunded_at: "2026-03-12", updated_by_hand: true },
      };
    }
    var n = parseInt(stage, 10) || 3;
    if (n < 1) n = 1;
    if (n > 8) n = 8;
    var stages = [];
    for (var i = 1; i <= n; i++) {
      stages.push({ n: i, name: stageName(i, market), current: i === n });
    }
    var delayed = kind === "delayed";
    var updated = new Date();
    if (kind === "stale") updated.setDate(updated.getDate() - 18);
    return {
      status: delayed ? "delayed" : "ok",
      message: delayed ? "Your delivery has moved by a week. You can still cancel before dispatch for a full refund." : "",
      order: {
        reference: "1042",
        stage: n,
        stage_name: stageName(n, market),
        stages: stages,
        stage_updated_at: updated.toISOString(),
        size_label: "King",
        size_dims: market === "ae" ? "180 × 200 cm" : "150 × 200 cm",
        delivery_window: "8 to 10 weeks",
        delivery_date: n >= 7 ? "2026-09-04" : null,
        delay_notice: delayed ? "Your delivery has moved by a week. You can still cancel before dispatch for a full refund." : null,
        revised_window: delayed ? "10 to 12 weeks" : null,
        batch_photo_url: null,
        updated_by_hand: true,
        reschedule: n === 6 || n === 7 ? previewReschedule() : { allowed: false },
        next:
          n === 7
            ? "Delivery is booked for 4 September 2026."
            : n === 8
              ? "Delivered."
              : "We will email at the next stage. This page is updated by hand, not live tracking.",
      },
    };
  }

  /* Preview only: weekdays from three days out to four weeks, so the panel
     can be seen without an order. The real list comes from the Worker. */
  function previewReschedule() {
    var dates = [], d = new Date();
    d.setUTCHours(12, 0, 0, 0);
    var start = new Date(d); start.setUTCDate(start.getUTCDate() + 3);
    var end = new Date(d); end.setUTCDate(end.getUTCDate() + 28);
    for (var x = new Date(start); x <= end; x.setUTCDate(x.getUTCDate() + 1)) {
      var w = x.getUTCDay();
      if (w !== 0 && w !== 6) dates.push(x.toISOString().slice(0, 10));
    }
    return { allowed: true, dates: dates, holidays: [], latest: end.toISOString().slice(0, 10), requested: null };
  }

  function render(root, payload, cfg) {
    var idle = qs(root, "[data-os-idle]");
    var result = qs(root, "[data-os-result]");
    var formNote = qs(root, "[data-os-form-note]");
    var status = (payload && payload.status) || "idle";

    if (formNote && (status === "sent" || status === "expired")) {
      formNote.hidden = false;
      formNote.textContent = payload.message || (status === "expired" ? EXPIRED : GENERIC);
    }

    if (!payload || status === "idle" || status === "sent" || status === "error") {
      if (idle) idle.hidden = false;
      if (result) {
        result.hidden = true;
        result.innerHTML = "";
      }
      if (status === "error" && formNote) {
        formNote.hidden = false;
        formNote.textContent = GENERIC;
      }
      if (status !== "sent" && status !== "expired" && status !== "error" && formNote) {
        formNote.hidden = true;
        formNote.textContent = "";
      }
      paintExplain(root, cfg.market);
      return;
    }

    if (idle) idle.hidden = true;
    if (result) result.hidden = false;
    if (status === "expired") {
      if (idle) idle.hidden = false;
      if (result) result.hidden = true;
      paintExplain(root, cfg.market);
      return;
    }

    result.innerHTML = orderHtml(status, payload, cfg, { reschedule: true });
  }

  /* The order card itself, shared by this page and the support page
     (window.OnniOrderStatus.render). Takes the status, the payload
     ({ message, order }) and cfg (contactPath). opts.reschedule false leaves
     out the delivery date picker, which needs a status page token. */
  function orderHtml(status, payload, cfg, opts) {
    opts = opts || {};
    var html = "";
    var order = (payload && payload.order) || {};
    if (status === "cancelled" || status === "refunded") {
      html += '<p class="section__lede">' + escapeHtml((payload && payload.message) || "") + "</p>";
      html += contactP(cfg);
      return html;
    }

    /* A heading like the page's others (h2, as "Change your delivery date"),
       so it takes the display face, weight and spacing from the theme. */
    html += '<h2 class="order-status__ref">Order ' + escapeHtml(order.reference || "") + "</h2>";
    if (order.size_label || order.size_dims) {
      html +=
        '<p class="order-status__meta">' +
        escapeHtml([order.size_label, order.size_dims].filter(Boolean).join(" · ")) +
        "</p>";
    }

    var windowLine = "";
    if (Number(order.stage) >= 7 && order.delivery_date) {
      windowLine = "Delivery date: " + escapeHtml(formatDate(order.delivery_date));
    } else if (order.revised_window) {
      windowLine = "Revised window: " + escapeHtml(order.revised_window);
    } else if (order.delivery_window) {
      windowLine = "Delivery window: " + escapeHtml(order.delivery_window);
    }
    if (windowLine) html += '<p class="order-status__meta">' + windowLine + "</p>";

    html += '<p class="reserve-panel__note">Updated by hand as your mattress moves through production. This is not live tracking.</p>';

    var staleDays = daysAgo(order.stage_updated_at);
    if (staleDays >= 14) {
      html +=
        '<p class="order-status__stale" role="status">Last updated ' +
        staleDays +
        ' days ago. Nothing has changed since then. <a href="' +
        escapeHtml(cfg.contactPath) +
        '">Contact us</a></p>';
    }

    if (status === "delayed" && (order.delay_notice || (payload && payload.message))) {
      var delayText = order.delay_notice || payload.message;
      html +=
        '<p class="order-status__delay" role="status">' +
        escapeHtml(delayText) +
        (order.revised_window ? " Revised window: " + escapeHtml(order.revised_window) + "." : "") +
        (/\bcancel\b/i.test(delayText) ? "" : " You can cancel before dispatch for a full refund.") +
        "</p>";
    }

    var exceptionText = exceptionMessage(order.exception);
    if (exceptionText) html += '<p class="order-status__delay" role="status">' + escapeHtml(exceptionText) + "</p>";

    var stages = order.stages || [];
    html += '<ol class="order-status__stages" aria-label="Order progress">';
    /* The Worker sends all eight stages, each marked done, current or
       upcoming. An older answer has only the stages reached and no flags:
       those are done unless current. Upcoming stages are greyed out. */
    stages.forEach(function (s) {
      var state = s.current ? "current" : s.upcoming && !s.done ? "upcoming" : "done";
      html +=
        '<li class="order-status__stage" data-state="' +
        state +
        '"><span class="order-status__num">' +
        escapeHtml(s.n) +
        "</span><span>" +
        escapeHtml(s.name) +
        (s.current ? " <em>(current)</em>" : "") +
        "</span></li>";
    });
    html += "</ol>";

    if (order.next) html += '<p class="order-status__next">' + escapeHtml(order.next) + "</p>";
    if (order.batch_photo_url && safeUrl(order.batch_photo_url)) {
      html +=
        '<figure class="order-status__photo"><img src="' +
        escapeHtml(order.batch_photo_url) +
        '" alt="Production run" width="1200" height="800" loading="lazy"></figure>';
    }
    if (opts.reschedule !== false) html += rescheduleHtml(order.reschedule);
    html += contactP(cfg);
    return html;
  }

  /* The Worker may send an exception as text or as { message }. Anything
     else is not shown rather than guessed at. */
  function exceptionMessage(ex) {
    if (!ex) return "";
    if (typeof ex === "string") return ex;
    if (typeof ex === "object" && typeof ex.message === "string") return ex.message;
    return "";
  }

  /* Only http(s) or same-site paths are ever put in a link or image. */
  function safeUrl(url) {
    var u = String(url || "").trim();
    return /^https?:\/\//i.test(u) || (/^\//.test(u) && !/^\/\//.test(u));
  }

  /* Which state an order on its own is in, for a lookup answer that carries
     the order but no page status. */
  function statusForOrder(order) {
    if (!order) return "ok";
    if (order.cancelled_at) return "cancelled";
    if (order.refunded_at) return "refunded";
    if (order.delay_notice) return "delayed";
    return "ok";
  }

  function closedMessage(status, order) {
    if (status === "cancelled") {
      return "This order was cancelled on " + formatDate(order.cancelled_at) + ". If that is wrong, contact us.";
    }
    if (status === "refunded") return "Refunded on " + formatDate(order.refunded_at) + ".";
    return "";
  }

  /* Order numbers are plain Shopify numbers (1001, 9999, longer in time).
     Spaces and one leading # are dropped; 1 to 10 digits are accepted.
     Returns the digits, or "" if it is not an order number. */
  function normaliseOrderNumber(raw) {
    var v = String(raw || "").replace(/\s+/g, "").replace(/^#/, "");
    return /^\d{1,10}$/.test(v) ? v : "";
  }

  /* Draw a found order into any container. Used by the support page after
     POST /apps/order/lookup answers { status: "found", order }. */
  function renderInto(container, order, opts) {
    if (!container) return;
    opts = opts || {};
    order = order || {};
    var cfg = { contactPath: opts.contactPath || "/pages/contact" };
    var status = statusForOrder(order);
    var payload = { order: order, message: closedMessage(status, order) };
    var html = orderHtml(status, payload, cfg, { reschedule: false });
    if (opts.statusUrl && safeUrl(opts.statusUrl)) {
      html += '<p class="order-status__full"><a href="' + escapeHtml(opts.statusUrl) + '">Open the full status page</a></p>';
    }
    container.innerHTML = html;
    container.hidden = false;
  }

  window.OnniOrderStatus = {
    render: renderInto,
    normaliseOrderNumber: normaliseOrderNumber,
    statusForOrder: statusForOrder,
  };

  /* Change the delivery date. Shown once delivery is being arranged or is
     booked, when the Worker says so. The Worker decides which dates are
     allowed (three working days' notice, up to four weeks, weekdays only, no
     bank holidays) and refuses anything else, so this only draws what it is
     given. Weekdays are laid out Monday to Friday so a week reads as a week;
     a bank holiday shows as unavailable rather than as an unexplained gap. */
  var DOW = ["Mon", "Tue", "Wed", "Thu", "Fri"];
  function isoDate(d) { return d.toISOString().slice(0, 10); }
  function utc(iso) { return new Date(iso + "T12:00:00Z"); }
  function shortLabel(iso) {
    return utc(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", timeZone: "UTC" });
  }
  /* "Wednesday 4 November", written out the British way. Built by hand so
     no browser slips a comma in after the weekday. */
  var DAY_NAMES = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  var MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August",
    "September", "October", "November", "December"];
  function longLabel(iso) {
    var d = utc(iso);
    if (!isFinite(d.getTime())) return String(iso || "");
    return DAY_NAMES[d.getUTCDay()] + " " + d.getUTCDate() + " " + MONTH_NAMES[d.getUTCMonth()];
  }

  function rescheduleHtml(rs) {
    /* Closer than three working days: the date can no longer be changed here
       (13.4.11). Say so, and how to reach us, instead of showing nothing. */
    if (rs && rs.closed && rs.message) {
      return '<section class="os-resched" data-os-resched><h2 class="os-resched__h">Change your delivery date</h2>' +
        '<p class="os-resched__note" role="status">' + escapeHtml(rs.message) + '</p></section>';
    }
    if (!rs || !rs.allowed || !rs.dates || !rs.dates.length) return "";
    var ok = {}, hol = {};
    rs.dates.forEach(function (d) { ok[d] = true; });
    (rs.holidays || []).forEach(function (d) { hol[d] = true; });

    var first = utc(rs.dates[0]);
    first.setUTCDate(first.getUTCDate() - ((first.getUTCDay() + 6) % 7)); /* back to Monday */
    var last = rs.latest || rs.dates[rs.dates.length - 1];

    /* 13.4.20 (Ben, 30 October 2026, Journey 1 1.35): a day before the first
       one offered stays closed, but pressing it says why and how to ask Ben
       for a sooner date, rather than doing nothing. */
    var sooner = rs.sooner || "We normally need three working days' notice to arrange a delivery, so the dates before that cannot be chosen here. If you need it sooner, reply to any of our emails or message us on WhatsApp, and Ben will see personally whether it is possible.";
    var html = '<section class="os-resched" data-os-resched data-os-sooner="' + escapeHtml(sooner) + '">';
    html += '<h2 class="os-resched__h">Change your delivery date</h2>';
    if (rs.requested) {
      html += '<p class="os-resched__note" role="status">You asked for <strong>' + escapeHtml(rs.requested.label) +
        "</strong>. We will email you once the courier confirms it. You can pick a different day below.</p>";
    } else {
      html += '<p class="os-resched__note">Pick a weekday at least three working days away and up to four weeks ahead. It is a request until the courier confirms it, which we email you, usually within one working day.</p>';
    }
    html += '<div class="os-cal" role="grid" aria-label="Available delivery dates">';
    html += '<div class="os-cal__row os-cal__row--head" role="row">' +
      DOW.map(function (d) { return '<span role="columnheader">' + d + "</span>"; }).join("") + "</div>";
    for (var w = new Date(first); isoDate(w) <= last; w.setUTCDate(w.getUTCDate() + 7)) {
      html += '<div class="os-cal__row" role="row">';
      for (var i = 0; i < 5; i++) {
        var d = new Date(w); d.setUTCDate(d.getUTCDate() + i);
        var iso = isoDate(d);
        if (ok[iso]) {
          var chosen = rs.requested && rs.requested.date === iso;
          html += '<button type="button" role="gridcell" class="os-cal__day' + (chosen ? " is-requested" : "") +
            '" data-os-date="' + iso + '" aria-pressed="false" aria-label="' + escapeHtml(longLabel(iso)) + '">' +
            escapeHtml(shortLabel(iso)) + "</button>";
        } else if (hol[iso]) {
          html += '<span role="gridcell" class="os-cal__day is-off" title="Bank holiday" aria-label="' +
            escapeHtml(longLabel(iso)) + ', bank holiday, unavailable">' + escapeHtml(shortLabel(iso)) + "<small>Bank hol</small></span>";
        } else if (iso < rs.dates[0]) {
          html += '<button type="button" role="gridcell" class="os-cal__day is-out" data-os-soon aria-disabled="true" aria-label="' +
            escapeHtml(longLabel(iso)) + ', too soon to choose here">' + escapeHtml(shortLabel(iso)) + "</button>";
        } else {
          html += '<span role="gridcell" class="os-cal__day is-out" aria-hidden="true">' + escapeHtml(shortLabel(iso)) + "</span>";
        }
      }
      html += "</div>";
    }
    html += "</div>";
    /* A click on a day only picks it. The request goes when the customer
       presses Confirm request here, so a slip on the grid sends nothing. */
    html += '<div class="os-resched__confirm" data-os-resched-confirm tabindex="-1">';
    html += '<p class="os-resched__ask" data-os-resched-ask role="status" aria-live="polite"></p>';
    html += '<div class="os-resched__actions" data-os-resched-actions hidden>';
    html += '<button type="button" class="btn os-resched__go" data-os-resched-go>Confirm request</button>';
    html += '<button type="button" class="os-resched__again" data-os-resched-clear>Choose another date</button>';
    html += "</div></div>";
    html += '<p class="os-resched__msg" data-os-resched-msg role="status" hidden></p>';
    html += "</section>";
    return html;
  }

  function wireReschedule(root, cfg) {
    var picked = "";
    var sending = false;

    function parts() {
      return {
        confirm: root.querySelector("[data-os-resched-confirm]"),
        ask: root.querySelector("[data-os-resched-ask]"),
        actions: root.querySelector("[data-os-resched-actions]"),
        go: root.querySelector("[data-os-resched-go]"),
        clear: root.querySelector("[data-os-resched-clear]"),
        msg: root.querySelector("[data-os-resched-msg]")
      };
    }

    function markPicked(iso) {
      root.querySelectorAll("[data-os-date]").forEach(function (b) {
        var on = !!iso && b.getAttribute("data-os-date") === iso;
        b.classList.toggle("is-picked", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }

    function hideConfirm(p) {
      if (p.ask) p.ask.textContent = "";
      if (p.actions) p.actions.hidden = true;
    }

    function pick(day) {
      var p = parts();
      picked = day.getAttribute("data-os-date");
      markPicked(picked);
      if (p.msg) { p.msg.hidden = true; p.msg.textContent = ""; }
      if (p.ask) p.ask.textContent = "Request " + longLabel(picked) + "?";
      if (p.actions) p.actions.hidden = false;
      if (p.go) { p.go.disabled = false; p.go.textContent = "Confirm request"; }
      if (p.clear) p.clear.disabled = false;
      if (p.confirm && p.confirm.focus) p.confirm.focus();
    }

    function clearPick() {
      var p = parts();
      var was = picked;
      picked = "";
      markPicked("");
      hideConfirm(p);
      var back = was && root.querySelector('[data-os-date="' + was + '"]');
      if (!back) back = root.querySelector("[data-os-date]");
      if (back && back.focus) back.focus();
    }

    function send() {
      var p = parts();
      var go = p.go;
      var date = picked;
      if (!go || !date || sending) return;
      function settle(ok, text) {
        sending = false;
        if (p.msg) { p.msg.hidden = false; p.msg.textContent = text; }
        if (p.clear) p.clear.disabled = false;
        if (ok) {
          root.querySelectorAll("[data-os-date]").forEach(function (b) {
            b.classList.toggle("is-requested", b.getAttribute("data-os-date") === date);
          });
          picked = "";
          markPicked("");
          hideConfirm(p);
          if (p.msg && p.msg.focus) { p.msg.setAttribute("tabindex", "-1"); p.msg.focus(); }
        } else {
          go.disabled = false;
          go.textContent = "Confirm request";
        }
      }
      sending = true;
      go.disabled = true;
      go.textContent = "Sending";
      if (p.clear) p.clear.disabled = true;
      if (cfg.preview || !cfg.token) {
        settle(false, "Preview: this would ask for " + longLabel(date) + ".");
        return;
      }
      fetch(endpoint(cfg) + "/reschedule", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ t: cfg.token, date: date })
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (data) {
          var ok = !!(data && data.status === "ok");
          var text = (data && data.message) ||
            (ok ? "Thank you. We have asked for " + longLabel(date) + " and will confirm by email." : "Something went wrong. Please try again.");
          settle(ok, text);
        })
        .catch(function () {
          settle(false, "That did not send. Check your connection and try again.");
        });
    }

    root.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      var day = e.target.closest("[data-os-date]");
      if (day) {
        if (!sending) pick(day);
        return;
      }
      if (e.target.closest("[data-os-soon]")) {
        var p = parts();
        var box = root.querySelector("[data-os-resched]");
        picked = "";
        markPicked("");
        hideConfirm(p);
        if (p.msg) { p.msg.hidden = false; p.msg.textContent = box ? box.getAttribute("data-os-sooner") : ""; }
        return;
      }
      if (e.target.closest("[data-os-resched-clear]")) {
        if (!sending) clearPick();
        return;
      }
      if (e.target.closest("[data-os-resched-go]")) send();
    });
  }

  function contactP(cfg) {
    return (
      '<p class="reserve-panel__note">Questions? <a href="' +
      escapeHtml(cfg.contactPath) +
      '">Contact us</a>.</p>'
    );
  }

  function paintExplain(root, market) {
    var list = qs(root, "[data-os-explain]");
    if (!list) return;
    list.innerHTML = explainStages(market)
      .map(function (s) {
        return (
          '<li class="order-status__stage" data-state="explain"><span class="order-status__num">' +
          s.n +
          "</span><span>" +
          escapeHtml(s.name) +
          "</span></li>"
        );
      })
      .join("");
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function endpoint(cfg) {
    return String(cfg.endpoint || "/apps/order").replace(/\/+$/, "");
  }

  function init(root) {
    if (!root) return;
    var cfg = {
      endpoint: root.getAttribute("data-lookup-endpoint") || "/apps/order",
      enabled: root.getAttribute("data-lookup-enabled") !== "false",
      preview: root.getAttribute("data-preview") === "true",
      market: root.getAttribute("data-market") || (document.documentElement.getAttribute("data-market") || "ae"),
      contactPath: root.getAttribute("data-contact-path") || "/pages/contact",
    };

    paintExplain(root, cfg.market);

    var params = new URLSearchParams(window.location.search);
    var token = params.get("t") || "";
    cfg.token = token;
    wireReschedule(root, cfg);
    var previewKind = params.get("preview") || "";
    var previewStage = params.get("stage") || "";

    /* From the order confirmation email: the order id and the key from the
       order's own Shopify status link. The Worker checks the key with Shopify
       and, if it matches, answers with the order and one of our tokens. The
       address bar is then swapped to the short token link, so the key is not
       left sitting in history or copied into a bookmark. */
    var linkOrder = params.get("o") || "";
    var linkKey = params.get("k") || "";

    if (cfg.preview && previewKind) {
      render(root, mockPayload(previewKind, previewStage, cfg.market), cfg);
    } else if (!token && linkOrder && linkKey && cfg.enabled) {
      fetch(endpoint(cfg) + "?o=" + encodeURIComponent(linkOrder) + "&k=" + encodeURIComponent(linkKey), {
        headers: { Accept: "application/json" }
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.token) {
            cfg.token = data.token;
            try {
              var clean = window.location.pathname + "?t=" + encodeURIComponent(data.token);
              window.history.replaceState(null, "", clean);
            } catch (e) {}
          }
          render(root, data, cfg);
        })
        .catch(function () {
          render(root, { status: "expired", message: EXPIRED }, cfg);
        });
    } else if (token && (cfg.enabled || cfg.preview)) {
      if (cfg.preview) {
        render(root, mockPayload("ok", previewStage || "4", cfg.market), cfg);
      } else {
        fetch(endpoint(cfg) + "?t=" + encodeURIComponent(token), { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (data) { render(root, data, cfg); })
          .catch(function () {
            render(root, { status: "sent", message: GENERIC }, cfg);
          });
      }
    }

    var form = qs(root, "[data-os-form]");
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (!cfg.enabled && !cfg.preview) return;
        var fd = new FormData(form);
        var rawOrder = String(fd.get("order") || "").trim();
        var order = normaliseOrderNumber(rawOrder);
        var email = String(fd.get("email") || "").trim();
        var formNote = qs(root, "[data-os-form-note]");
        if (!order) {
          if (formNote) {
            formNote.hidden = false;
            formNote.textContent = "That does not look like an order number. It is the number in your confirmation email, for example 1001.";
          }
          return;
        }
        var btn = form.querySelector('button[type="submit"]');
        if (btn) btn.disabled = true;
        function done(data) {
          if (btn) btn.disabled = false;
          /* New Worker: the order straight away, or a plain "not found".
             Older Worker: { status: "sent" } and a link by email. */
          if (data && data.status === "found" && data.order) {
            render(root, { status: statusForOrder(data.order), message: closedMessage(statusForOrder(data.order), data.order), order: data.order }, cfg);
            if (formNote) { formNote.hidden = true; formNote.textContent = ""; }
            return;
          }
          if (data && data.status === "not_found") {
            render(root, { status: "idle" }, cfg);
            if (formNote) {
              formNote.hidden = false;
              formNote.textContent = data.message || NOT_FOUND;
            }
            return;
          }
          render(root, { status: "sent", message: (data && data.message) || GENERIC }, cfg);
        }
        if (cfg.preview) {
          done();
          return;
        }
        fetch(endpoint(cfg) + "/lookup", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ order: order, email: email }),
        })
          .then(function (r) { return r.json().catch(function () { return null; }); })
          .then(function (data) { done(data); })
          .catch(function () { done(null); });
      });
    }

    root.querySelectorAll("[data-os-preview-state]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var kind = btn.getAttribute("data-os-preview-state");
        var stage = btn.getAttribute("data-os-preview-stage") || "";
        if (kind === "idle") render(root, { status: "idle" }, cfg);
        else render(root, mockPayload(kind, stage, cfg.market), cfg);
      });
    });
  }

  function boot() {
    document.querySelectorAll("[data-order-status]").forEach(init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();
